
import { Vue, Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class FormSelect extends Vue {
  @Prop({ default: null }) value!: any; // The predefined value(s)
  @Prop({ default: () => [] }) options!: any[]; // The list of options
  @Prop({ type: String, default: "" }) readonly name!: string;
  @Prop({ type: String, default: "Select option" })
  readonly placeholder!: string;
  @Prop({ type: Function, default: null }) readonly search!: (
    search: string,
    loading: (loading: boolean) => void
  ) => void;
  @Prop({ type: String, default: "" }) readonly inputClass!: string;
  @Prop({ type: String, default: "" }) readonly getParentCustom!: string;
  @Prop({ type: Boolean, default: false }) readonly multiple!: boolean; // Multi-select control

  internalValue = this.findOptionsByValue(this.value); // Initialize with the predefined value(s)
  internalIsLoading = false; // Internal state for loading

  @Watch("value", { immediate: true })
  onValueChange(newValue: any) {
    this.internalValue = this.findOptionsByValue(newValue); // Update internalValue when value prop changes
  }

  // Find the option objects that match the predefined value(s)
  findOptionsByValue(value: any) {
  if (this.multiple && Array.isArray(value)) {
    return value
      .map((val) => {
        if (typeof val === "object") {
          return this.options.find((option) => option.value === val.value) || null;
        }
        return this.options.find((option) => option.value === val) || null;
      })
      .filter(Boolean);
  }
  if (typeof value === "object") {
    return this.options.find((option) => option.value === value.value) || null;
  }
  return this.options.find((option) => option.value === value) || null;
}

updateValue(newValue: any): void {
  if (this.multiple && Array.isArray(newValue)) {
    this.$emit(
      "input",
      newValue.map((option) => option?.value || null)
    ); // Emit an array of selected values
  } else {
    this.$emit("input", newValue?.value || null); // Emit a single value
  }
}

  handleSearch(searchTerm: string) {
    if (this.search) {
      this.search(searchTerm, (loading: boolean) => {
        this.internalIsLoading = loading; // Update internal loading state
      });
    }
  }

  handleClose() {
    this.$emit("close");
  }

  get classes(): object {
    return {
      [this.inputClass]: true,
    };
  }
}
